import React from 'react'
import { ControlProps } from '../form-control-props';
import { withFormControlWrapper } from '../FormControlWrapper';


const InputTextareaControl: React.FC<ControlProps> = ({
    value,
    name,
    placeholder,
    className,
    onBlur,
    onChange,
    cols,
    rows,
}) => {

    return (
        <textarea
            value={value as string}
            name={name}
            placeholder={placeholder}
            className={`${className} appearance-none`}
            onBlur={onBlur}
            onChange={onChange}
            cols={cols}
            rows={rows}
        />
    )
}

export default withFormControlWrapper(
    React.memo(InputTextareaControl, (prevProps, nextProps) => {
        return prevProps.value === nextProps.value
            && prevProps.className === nextProps.className
            && prevProps.placeholder === nextProps.placeholder
    })
)
